import { isNotEmpty } from '@doltech/utils/lib/text';
import { range } from 'lodash';
import { Instance, types as t } from 'mobx-state-tree';

import {
  preProcessor,
  TableCompletion,
  TableCompletionUserAnswerInstance,
} from '../../../question-data-model/Question/_implementations/table-completion.store';
import { TestQuestionStore } from '../test-question.store';

interface AnswerQuestionInput {
  text: string;
  blankId: string;
}

const DoTestTableCompletionBase = t
  .compose(TestQuestionStore, TableCompletion)
  .named('DoTestTableCompletion')
  .actions((self) => ({
    onAnswerQuestion(input: AnswerQuestionInput) {
      const { blankId, text } = input;
      const found = self.userAnswers.find((answer) => answer.blankId === blankId);
      if (found) {
        found.userAnswer = text;
      } else {
        self.userAnswers.push({
          blankId,
          userAnswer: text,
        });
      }
    },
    setEditorValue(value) {
      self.editorValue = value;
    },
  }))
  .views(() => ({
    isAnswered(answer: TableCompletionUserAnswerInstance) {
      return answer && isNotEmpty(answer.userAnswer);
    },
  }))
  .views((self) => ({
    get groupName() {
      return 'Table Completion';
    },

    get formattedQuestionNo() {
      return self.no;
    },

    get bottomBarQuestionNoes() {
      return range(self.blanks.length)
        .map((noIndex) => {
          const no = self.no + noIndex;
          return {
            no,
            answered: self.isAnswered(
              self.userAnswers.find((_u, userAnswerIndex) => userAnswerIndex === noIndex)
            ),
          };
        })
        .filter((item) => Boolean(item));
    },

    get questionCount() {
      return self.blanks.length;
    },

    get answerCount() {
      return self.userAnswers.reduce(
        (total, answer) => total + (self.isAnswered(answer) ? 1 : 0),
        0
      );
    },

    prepareDataForSubmit() {
      return {
        editorValue: self.editorValue,
        questionId: self.uuid,
        type: self.type as any,
        userAnswers: self.userAnswers,
      };
    },
  }));

export const DoTestTableCompletion = t.snapshotProcessor(DoTestTableCompletionBase, {
  preProcessor,
});

export interface DoTestTableCompletionInstance extends Instance<typeof DoTestTableCompletion> {}
